import { render, staticRenderFns } from "./screenBillAdmin.vue?vue&type=template&id=d73bec42&scoped=true"
import script from "./screenBillAdmin.vue?vue&type=script&lang=js"
export * from "./screenBillAdmin.vue?vue&type=script&lang=js"
import style0 from "./screenBillAdmin.vue?vue&type=style&index=0&id=d73bec42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d73bec42",
  null
  
)

export default component.exports